import React, { useContext, useEffect } from 'react'
import { PageTitle } from '../../../_metronic/layout/core'
import BedRockContext from '../../BedRockContext'
import { WifiSettingsContent } from './WifiSettingsContent'

const WifiSettingsPage = () => {
    const myData = useContext(BedRockContext)

    useEffect(() => {
        myData.setBaseData({ toolBarButtons: [] })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <PageTitle>Network Settings</PageTitle>
            <WifiSettingsContent />
        </>
    )
}

export { WifiSettingsPage }
